import React from 'react';
import styled from 'styled-components';
import { array, string } from 'prop-types';
import VerifiedBadge from '../../../images/verified-badge.svg';

const HighlightBox = styled.span`
  width: fit-content;
  display: ${({ display }) => display};
  align-items: center;
  margin: auto
  white-space: nowrap;
  height: 18px;
  background-color: #24A148;
  ${({ display }) => display === 'unset' && 'margin-left: 5px;'}
  border-radius: 8px 0px 8px 0px;
  vertical-align: middle;
  padding: 2px 4px;
  font-size: 10px;
  font-weight: 700;
`;

const HighlightText = styled.span`
  vertical-align: middle;
  margin-left: 2px;
  color: #FFF;
  text-transform: uppercase;
  font-size: 10px;
  font-weight: 700;
`;

const Image = styled.img`
  vertical-align: middle;
  display: inherit;
`;

const VerifiedHighlight = ({ children, display }) => (
  <HighlightBox display={display}>
    <Image alt="verified simbol" src={VerifiedBadge} />
    <HighlightText>
      {children}
    </HighlightText>
  </HighlightBox>
);

VerifiedHighlight.propTypes = {
  children: array.isRequired,
  display: string,
};

VerifiedHighlight.defaultProps = {
  display: 'unset',
};

export default VerifiedHighlight;
